jQuery(document).ready(function ($) {
    // Attach custom classes to WPCF7 Acceptance
    if ($('.wpcf7').length){
        $('.wpcf7-acceptance').find('.wpcf7-list-item').addClass('checkbox');
        $('.wpcf7-acceptance').find('input').addClass('checkbox__input');
        $('.wpcf7-acceptance').find('.wpcf7-list-item-label').addClass('checkbox__label');
    }
});